import { render, staticRenderFns } from "./AddScan.vue?vue&type=template&id=51a970e6&"
import script from "./AddScan.vue?vue&type=script&lang=js&"
export * from "./AddScan.vue?vue&type=script&lang=js&"
import style0 from "./AddScan.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddScan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports